import type { AuthUserJWT } from "@/types/auth";

import { useAuth } from "@/contexts/AuthContext";

// A per-organization sphinx flag, carried in the access token.
export const isDocsEnabledForUser = (
  user: Pick<AuthUserJWT, "feature_flags"> | null | undefined,
): boolean => user?.feature_flags?.includes("docs") ?? false;

export const useIsDocsEnabled = (): boolean =>
  isDocsEnabledForUser(useAuth().user);
